import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-0005b78d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "navigation-list" }
const _hoisted_4 = {
  class: "navigation-list__item",
  delay: 200
}
const _hoisted_5 = {
  class: "navigation-list__item",
  delay: 300
}
const _hoisted_6 = {
  class: "navigation-list__item",
  delay: 400
}
const _hoisted_7 = {
  class: "navigation-list__item",
  delay: 500
}
const _hoisted_8 = {
  class: "navigation-list__item",
  delay: 600
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion_fade = _resolveDirective("motion-fade")!
  const _directive_motion_slide_to_top = _resolveDirective("motion-slide-to-top")!

  return (_openBlock(), _createElementBlock("header", null, [
    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
      class: "logo",
      to: "/",
      delay: 300
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })), [
      [_directive_motion_fade]
    ]),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_4, [
          _createElementVNode("a", {
            class: "navigation-list__item-link underline-hover",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.HowItWorks)), ["stop"]))
          }, " How It Works ")
        ])), [
          [_directive_motion_slide_to_top]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_5, [
          _createElementVNode("a", {
            class: "navigation-list__item-link underline-hover",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Products)), ["stop"]))
          }, " Products ")
        ])), [
          [_directive_motion_slide_to_top]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, [
          _createElementVNode("a", {
            class: "navigation-list__item-link underline-hover",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Shopify)), ["stop"]))
          }, " Shopify ")
        ])), [
          [_directive_motion_slide_to_top]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_7, [
          _createElementVNode("a", {
            class: "navigation-list__item-link underline-hover",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Testimonials)), ["stop"]))
          }, " Testimonials ")
        ])), [
          [_directive_motion_slide_to_top]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_8, [
          _createElementVNode("a", {
            class: "navigation-list__item-link underline-hover",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Plans)), ["stop"]))
          }, " Pricing ")
        ])), [
          [_directive_motion_slide_to_top]
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Button, {
      delay: 300,
      secondary: "",
      class: "contact-us",
      text: "Contact us",
      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.scrollToSection($setup.NavigationSections.ContactUs)))
    }, null, 512), [
      [_directive_motion_fade]
    ])
  ]))
}